import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Clock, ArrowRight } from 'lucide-react';
import { useT } from '../services/i18n';
import { productsAPI, uploadsAPI } from '../services/api';

// Blog guides about a part: product page (productId) or category / subcategory page (category + sub)
export const RelatedGuidesBlock = ({ productId, category, sub, model, variant = 'product' }) => {
  const { t, lang } = useT();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    setData(null);
    const req = productId ? productsAPI.getGuides(productId, lang) : category ? productsAPI.categoryGuides(category, sub, lang) : model?.categories?.length ? productsAPI.modelGuides(model.categories, model.subcategories || [], model.part || '', lang) : null;
    if (!req) return undefined;
    req.then((d) => alive && setData(d)).catch(() => alive && setData({ items: [] }));
    return () => { alive = false; };
  }, [productId, category, sub, model?.key, lang]);
  if (!data?.items?.length) return null;
  const page = variant !== 'product';
  return (
    <section className={page ? 'bg-white rounded-xl shadow-sm p-6 mt-8' : 'bg-white rounded-lg shadow-sm p-4 mb-6'} data-testid={`${variant}-guides`}>
      <h2 className={`${page ? 'text-lg font-bold mb-4' : 'text-sm font-semibold mb-3'} text-gray-900 flex items-center gap-2`}><BookOpen size={page ? 18 : 16} className="text-orange-500" /> {t('product.guides', { part: data.part })}</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {data.items.map((a, i) => (
          <li key={a.id}>
            <Link to={a.path} data-testid={`${variant}-guide-${i}`} className="group flex sm:flex-col gap-3 border border-gray-200 rounded-lg p-3 h-full hover:border-orange-400 hover:shadow-sm transition-all">
              {a.image && <img src={uploadsAPI.resolveUrl(a.image)} alt={a.title} loading="lazy" className="w-24 h-20 sm:w-full sm:h-32 object-cover rounded-md flex-shrink-0 no-placeholder" />}
              <span className="flex-1 flex flex-col">
                <span className="text-sm font-semibold text-gray-900 group-hover:text-orange-600 leading-snug line-clamp-2">{a.title}</span>
                {a.description && <span className="text-xs text-gray-500 mt-1 line-clamp-2">{a.description}</span>}
                <span className="mt-auto pt-2 text-xs text-orange-600 font-medium inline-flex items-center gap-2">
                  {a.read_time && <span className="inline-flex items-center gap-1 text-gray-400"><Clock size={11} /> {a.read_time}</span>}
                  {t('product.readGuide')} <ArrowRight size={12} />
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
